<template>
  <b-card>
    <b-row>
      <b-col sm="10">
        <h5>Dispositivos Aprovisionados</h5>
      </b-col>
      <b-col class="text-right">
        <b-dropdown
          id="dropdown-1"
          right
          variant="flat"
          class="dropdown-icon-wrapper"
        >
          <template #button-content>
            <feather-icon
              icon="AlignJustifyIcon"
              size="16"
              class="align-middle"
            />
          </template>
          <b-dropdown-item @click="onExport('xls')">
            <feather-icon
              icon="PrinterIcon"
              size="18"
            />
            Dowload XLS
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <Grid
      :fields="fields"
      :items="items"
      :show-border="false"
      :show-search="false"
      :show-loading="isLoading"
      @onChangePage="getData"
    >
      <template #search>
        <b-row>
          <b-col sm="4">
            <i2-form-date-range
              v-model="search.dates"
              label=""
              placeholder="Data de Aprovisionamento"
              @onSelect="onSelect"
              @onClear="onClearData"
            />
          </b-col>
          <b-col sm="4">
            <i2-form-input
              v-model="search.serial"
              label=""
              placeholder="Seriais"
            />
          </b-col>
          <b-col sm="3">
            <organization-select v-model="search.organizations" :multiple="true" :show-label="false" />
          </b-col>
          <b-col sm="1">
            <i2-icon-button
              icon="SearchIcon"
              variant="outline-primary"
              class="mr-1"
              @click="getData"
            />
          </b-col>
        </b-row>
      </template>
      <template #cell(serial)="data">
        <u><span style="font-size: 10pt" @click="onShowDeviceDetails(data.item)">{{ data.item.serial }}</span></u>
      </template>
      <template #cell(provisioning_date)="data">
        {{ data.item.provisioning_date | moment('DD/MM/YYYY hh:mm') }}
      </template>
      <template #cell(last_session)="data">
        {{ data.item.last_session | moment('DD/MM/YYYY') }}
      </template>
    </Grid>
    <device-detail v-model="currentDevice" :show="showDevideDetails" @onClose="onCloseDeviceDetails" />
  </b-card>
</template>

<script>
import moment from 'moment-timezone'
import I2FormDateRange from '@/components/i2/forms/elements/I2FormDateRange'
import DeviceDetailMixin from '@/mixins/DeviceDetailMixin'
import DeviceDetail from '@/components/app/Device/DeviceDetail'
import OrganizationSelect from '@/components/app/Organization/OrganizationSelect'

export default {
  name: 'ProvisionedDevicesTable',
  components: {
    I2FormDateRange,
    DeviceDetail,
    OrganizationSelect,
  },
  mixins: [DeviceDetailMixin],
  data() {
    return {
      isLoading: false,
      search: {
        start_date: '',
        end_date: '',
        organizations: [],
        query_filter: 'provisioned',

      },
      date_range: {
        startDate: null,
        endDate: null,
      },
      fields: [
        {
          key: 'serial',
          label: 'Serial',
          class: 'w-2',
        },
        {
          key: 'provisioning_date',
          label: 'Data de Aprovisionamento',
          class: 'w-2',
          sortable: true,
        },
        {
          key: 'last_session',
          label: 'Data de acesso',
          class: 'w-2',
          sortable: true,
        },
        {
          key: 'last_user',
          label: 'Último usuário',
          class: 'w-2',
          sortable: true,
        },
      ],
      items: { data: [] },
    }

  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(page) {
      this.isLoading = true
      this.$http.showLoader = false
      this.items = await this.$search.get(
        'devices',
        page,
        this.search,
        null,
      )
      this.isLoading = false
      this.$http.showLoader = true
    },
    onSelect(data) {
      this.search.start_date = moment(data.startDate).format('YYYY-MM-DD')
      this.search.end_date = moment(data.endDate).format('YYYY-MM-DD')
      this.getData()
    },
    onClearData() {
      this.search.start_date = ''
      this.search.end_date = ''
      this.getData()
    },
    async onExport(format) {

      const response = await this.$search.get(
        'devices/export',
        null,
        this.search,
        null,
      )
      if (response.url !== '') {
        window.open(response.url, '_blank')
        return
      }
      this.$notify.success(response.message)

    },
  },

}
</script>

<style scoped>

</style>
